module.exports = __webpack_public_path__ + "img/sks11.285fe0d9.jpg";